import React, { useState } from "react";
import "./withdraw.css";

const Withdraw = () => {
  // State Variables
  const [balance, setBalance] = useState(500); // Example balance, replace with API data
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("bank");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [preview, setPreview] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);

  // Withdrawal Fees
  const fees = {
    bank: 5,
    crypto: 2,
    paypal: 3.5,
  };

  // Handle amount input
  const handleAmountChange = (e) => {
    let inputAmount = parseFloat(e.target.value);
    setAmount(e.target.value);

    if (!inputAmount || inputAmount <= 0) {
      setPreview("Enter a valid amount");
      setIsDisabled(true);
    } else if (inputAmount > balance) {
      setPreview("Insufficient balance!");
      setIsDisabled(true);
    } else {
      let fee = fees[method] || 0;
      let finalAmount = inputAmount - fee;

      if (finalAmount < 0) {
        setPreview("Amount too low after fees!");
        setIsDisabled(true);
      } else {
        setPreview(`You will receive: $${finalAmount.toFixed(2)} (after $${fee} fee)`);
        setIsDisabled(false);
      }
    }
  };

  // Handle method change
  const handleMethodChange = (e) => {
    setMethod(e.target.value);
    setBankName(""); // Reset bank details when method changes
    setAccountNumber("");
    handleAmountChange({ target: { value: amount } }); // Recalculate fees
  };

  // Handle withdrawal
  const handleWithdraw = () => {
    if (method === "bank" && (!bankName || !accountNumber)) {
      alert("Please enter bank name and account number.");
      return;
    }

    let inputAmount = parseFloat(amount);
    if (inputAmount > 0 && inputAmount <= balance) {
      let confirmation = window.confirm(`Confirm withdrawal of $${inputAmount} via ${method.toUpperCase()}?`);
      if (confirmation) {
        setBalance(balance - inputAmount);
        setAmount("");
        setBankName("");
        setAccountNumber("");
        setPreview("Withdrawal successful!");
        setIsDisabled(true);

        // Simulate backend call
        setTimeout(() => {
          alert(`Withdrawal of $${inputAmount} via ${method.toUpperCase()} is processing!`);
        }, 1000);
      }
    } else {
      alert("Invalid withdrawal request!");
    }
  };

  return (
    <div className="withdraw-container">
      <h1 className="withdraw-title">Withdraw Funds</h1>
      <p className="balance-display">Available Balance: ${balance}</p>

      {/* Withdrawal Method */}
      <label htmlFor="withdraw-method">Select Withdrawal Method:</label>
      <select id="withdraw-method" className="withdraw-input" value={method} onChange={handleMethodChange}>
        <option value="bank">Bank Transfer</option>
        <option value="crypto">Crypto Wallet</option>
        <option value="paypal">PayPal</option>
      </select>

      {/* Bank Transfer Fields (Only show if Bank Transfer is selected) */}
      {method === "bank" && (
        <>
          <input
            type="text"
            id="bank-name"
            className="withdraw-input"
            placeholder="Enter Bank Name"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
          />

          <input
            type="number"
            id="account-number"
            className="withdraw-input"
            placeholder="Enter Account Number"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
          />
        </>
      )}

      {/* Withdrawal Amount */}
      <input
        type="number"
        id="withdraw-amount"
        className="withdraw-input"
        placeholder="Enter amount"
        value={amount}
        onChange={handleAmountChange}
      />

      <p className="amount-preview">{preview}</p>

      {/* Withdraw Button */}
      <button className="withdraw-btn" onClick={handleWithdraw} disabled={isDisabled}>
        Withdraw
      </button>
    </div>
  );
};

export default Withdraw;
